module["exports"] = [
  "gmail.com",
  "yahoo.com",
  "hotmail.com"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/en/internet/free_email.js
 ** module id = 461
 ** module chunks = 0
 **/